export const LEGACY_AUTH_STORAGE_KEYS = [
  "token",
  "accessToken",
  "refreshToken",
  "refresh_token",
  "authToken",
];

export const TOKEN_AUTH_USER_FIELDS = [
  "token",
  "accessToken",
  "refreshToken",
  "refresh_token",
];

export const SENSITIVE_PERSISTED_AUTH_USER_FIELDS = [
  ...TOKEN_AUTH_USER_FIELDS,
  "socket_token",
  "ws_url",
];

function getStorage(storage) {
  return storage || (typeof window !== "undefined" ? window.localStorage : null);
}

function isObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export function buildSafeAuthUser(authPayload = null) {
  const runtimeUser = buildRuntimeAuthUser(authPayload);
  if (!runtimeUser) return null;

  SENSITIVE_PERSISTED_AUTH_USER_FIELDS.forEach((field) => {
    delete runtimeUser[field];
  });

  return runtimeUser;
}

export function buildRuntimeAuthUser(authPayload = null) {
  if (!isObject(authPayload)) return null;

  const source = isObject(authPayload.user)
    ? {
        permissions: authPayload.permissions,
        ...authPayload.user,
        clients: authPayload.clients,
        socket_token: authPayload.socket_token,
        ws_url: authPayload.ws_url,
        selectedClient:
          authPayload.user.selectedClient !== undefined
            ? authPayload.user.selectedClient
            : authPayload.selectedClient,
      }
    : { ...authPayload };

  TOKEN_AUTH_USER_FIELDS.forEach((field) => {
    delete source[field];
  });

  return source;
}

export function persistSafeAuthUser(authPayload, storage) {
  const targetStorage = getStorage(storage);
  const safeUser = buildSafeAuthUser(authPayload);

  if (!targetStorage) return safeUser;

  clearLegacyAuthKeys(targetStorage);

  if (safeUser) {
    targetStorage.setItem("user", JSON.stringify(safeUser));
  } else {
    targetStorage.removeItem("user");
  }

  return safeUser;
}

export function readSafeStoredUser(storage) {
  const targetStorage = getStorage(storage);
  if (!targetStorage) return null;

  clearLegacyAuthKeys(targetStorage);

  const storedUser = targetStorage.getItem("user");
  if (!storedUser) return null;

  try {
    const parsedUser = JSON.parse(storedUser);
    const safeUser = buildSafeAuthUser(parsedUser);

    if (safeUser) {
      targetStorage.setItem("user", JSON.stringify(safeUser));
    } else {
      targetStorage.removeItem("user");
    }

    return safeUser;
  } catch (error) {
    targetStorage.removeItem("user");
    return null;
  }
}

export function clearLegacyAuthStorage(storage) {
  const targetStorage = getStorage(storage);
  if (!targetStorage) return;

  clearLegacyAuthKeys(targetStorage);
  targetStorage.removeItem("user");
}

export function clearLegacyAuthKeys(storage) {
  const targetStorage = getStorage(storage);
  if (!targetStorage) return;

  LEGACY_AUTH_STORAGE_KEYS.forEach((key) => {
    targetStorage.removeItem(key);
  });
}
